export default __webpack_public_path__ + "static/bariol_serif_regular-webfont-e6084cf5ca88d6916867fd707fc8288c.woff2";